export default "__VITE_ASSET__5d059d86__"